import { Dispatch, FC, memo, SetStateAction } from 'react';
import { Text } from '../../../../components-v4';
import { MOBILE_STORES } from '../../../../constants';
import { MobileStore } from '../../../../types';
import { TabsContainer, Tab } from './tabs.styled';

type TabsProps = {
  activeTab: MobileStore;
  setTab: Dispatch<SetStateAction<MobileStore>>;
};

export const Tabs: FC<TabsProps> = memo(({ activeTab, setTab }) => {
  return (
    <TabsContainer>
      {MOBILE_STORES.map((app, i) => (
        <Tab
          key={i}
          $isSelected={activeTab === app.value}
          onClick={() => setTab(app.value)}
        >
          <Text
            variant="body-14"
            color={activeTab === app.value ? 'primary.600' : 'gray.800'}
            whiteSpace="nowrap"
          >
            {app.text}
          </Text>
        </Tab>
      ))}
    </TabsContainer>
  );
});
